var __templateData = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper;

  return "  <a href=\"#\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-expanded=\"false\">\r\n    <span class=\"glyphicon glyphicon-shopping-cart\"></span> "
    + container.escapeExpression(((helper = (helper = helpers.cartLength || (depth0 != null ? depth0.cartLength : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"cartLength","hash":{},"data":data}) : helper)))
    + " conseil(s)<span class=\"caret\"></span>\r\n  </a>\r\n  <ul class=\"dropdown-menu dropdown-cart\" role=\"menu\" id=\"cart-content\">\r\n"
    + ((stack1 = container.invokePartial(partials["top-cart-resume"],depth0,{"name":"top-cart-resume","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "  </ul>\r\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.cartLength : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}